// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bulgaria */
const BG = /^(?:(?:43[07-9]|99[69]\d)\d{5}|(?:8[7-9]|98)\d{7})$/;

export default BG;
